import EmptyState from 'hb-builder/components/common/state/EmptyState';
import { useBuilderConfigContext } from 'hb-builder/contexts/BuilderConfigContext';

const EmptyDynamicState = ({ component, type, ...styleProps }) => {
  const {
    hivebrite: { networkColors },
  } = useBuilderConfigContext();

  return (
    <EmptyState
      {...styleProps}
      bg={networkColors?.fo_background_color}
      color="inherit"
      fontFamily="Inter"
      height="300px"
      width="100%"
    >
      {s__(
        "Builder|You don't have published any %{type} to display in the %{component} at the moment",
      ).i__({ component, type })}
    </EmptyState>
  );
};

export default EmptyDynamicState;
